export default __webpack_public_path__ + "static/share-image-c7813b85808ea63290fb436cd4bce762.jpg";